import { PageState } from "../../views/Home/HomeUtils";
import { Transition, Variants } from "framer-motion";

/**
 * Estados disponibles para el Header
 */
export enum HeaderState {
	Normal = 0,
	Extended = 1,
	Collapse = 2,
}

/**
 * Labels para los distintos estados del Header de acuerdo al PageState.
 */
export const labels: Record<PageState, string> = {
	[PageState.AssistanceAdjust]: "Inicia haciendo los Ajustes de asistencia del día de hoy.",
	[PageState.Patients]: "Continúa asignando al personal y haciendo el Cambio de turno.",
	[PageState.PlanificationAssistance]:
		"Planifica turnos, días de descanso y personal disponible subiendo la plantilla automatizada.",
	[PageState.NursingFunctions]: "Gestiona y asigna funciones clave al personal de enfermería.",
	[PageState.Dashboard]: "",
};

/* Interfaces para las listas de elementos obtenidas del API */
export interface HospitalItem {
	id: string;
	name: string;
	hospitalNumber: number;
}

export interface FloorItem {
	id: string;
	name: string;
	hospital_id: string;
}

export interface AreaItem {
	id: string;
	name: string;
	floor_id: string;
}

/* Configuración de animaciones  */
export const variantsLogo: Variants = {
	initial: {
		x: "5rem",
	},
	visible: {
		x: 0,
	},
	exit: {
		x: "50rem",
		zIndex: 3,
	},
};

export const variantsName: Variants = {
	initial: {
		x: "-5rem",
		opacity: 0,
		zIndex: 2,
	},
	visible: {
		x: 0,
		opacity: 1,
		zIndex: 1,
	},
	exit: {
		x: "-20rem",
		opacity: 0,
		zIndex: 3,
	},
};

export const variantsArea: Variants = {
	initial: {
		y: "-5rem",
		opacity: 0,
		zIndex: 2,
	},
	visible: {
		y: 0,
		opacity: 1,
		width: "auto",
		zIndex: 1,
	},
	exit: {
		y: "-20rem",
		opacity: 0,
		zIndex: 3,
	},
};

export const variantsDate: Variants = {
	initial: {
		opacity: 0,
		zIndex: 5,
	},
	visible: {
		opacity: 1,
		zIndex: 2,
	},
	exit: {
		opacity: 0,
		zIndex: 5,
	},
};

export const variantsDateLabel: Variants = {
	initial: {
		y: "-120%",
		opacity: 0,
	},
	visible: {
		y: "35%",
		opacity: 1,
	},
	exit: {
		y: "-120%",
		opacity: 0,
	},
};

export const variantsDateLabelCollapse: Variants = {
	initial: {
		y: "-250%",
		opacity: 0,
	},
	visible: {
		y: "-30%",
		opacity: 1,
	},
	exit: {
		y: "-250%",
		opacity: 0,
	},
};

export const variantsButtons: Variants = {
	initial: {
		x: "5rem",
		opacity: 0,
	},
	visible: {
		width: "auto",
		x: 0,
		opacity: 1,
	},
	exit: {
		x: "1rem",
		opacity: 0,
	},
};

export const transition: Transition = {
	duration: 0.6,
	ease: [0.25, 0.1, 0.25, 1],
};
